var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 19.9997L11.9987 15.9997M15.9987 19.9997C17.8612 19.2913 19.6479 18.398 21.332 17.333M15.9987 19.9997V26.6663C15.9987 26.6663 20.0387 25.933 21.332 23.9997C22.772 21.8397 21.332 17.333 21.332 17.333M11.9987 15.9997C12.7082 14.1589 13.6016 12.3944 14.6654 10.733C16.2189 8.24899 18.3822 6.20374 20.9494 4.7918C23.5165 3.37986 26.4023 2.64817 29.332 2.66635C29.332 6.29301 28.292 12.6663 21.332 17.333M11.9987 15.9997H5.33203C5.33203 15.9997 6.06536 11.9597 7.9987 10.6663C10.1587 9.22635 14.6654 10.6663 14.6654 10.6663M5.9987 21.9997C3.9987 23.6797 3.33203 28.6663 3.33203 28.6663C3.33203 28.6663 8.3187 27.9997 9.9987 25.9997C10.9454 24.8797 10.932 23.1597 9.8787 22.1197C9.36044 21.625 8.67776 21.3392 7.96167 21.317C7.24558 21.2949 6.54653 21.538 5.9987 21.9997Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.b8fce915e73b9411f939af001d7a9967.svg";
export { ForwardRef as ReactComponent };